module.exports = __webpack_public_path__ + "static/media/part-12.f2ae4ecc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-12.jpg
// module id = 945
// module chunks = 0